export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7617.9772f661.jpg";